<template>
  <div class="h-100 d-flex flex-column">
    <!-- Row: title and resize button -->
    <div class="row f-row mb-2 markets-chart-title d-flex align-items-center">
      <div class="col col-6" style="font-size: 1rem">
        Percentiles ({{ title.toLowerCase() }} candles)
      </div>
      <slot name="spot"></slot>
    </div>
    <!-- Row: controls and labels -->
    <div
      class="row f-row"
      style="vertical-align: middle!important; padding: 0 60px 0 10px!important;"
    >
      <div class="col col-12">
        <div
          class="row f-row txt-label-primary-2"
          id="percentileControls2"
          style="vertical-align: middle!important;"
        >
          <div class="col col-4 text-center ml-2">
            <div
              class="btn-toolbar"
              role="toolbar"
              aria-label="Toolbar with button groups"
            >
              <div class="btn-group btn-group-toggle btn-block" role="group">
                &nbsp;
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('6M')"
                  v-bind:class="[pickedDate === '6M' ? 'active' : '']"
                >
                  6M
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('1Y')"
                  v-bind:class="[pickedDate === '1Y' ? 'active' : '']"
                >
                  1Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('2Y')"
                  v-bind:class="[pickedDate === '2Y' ? 'active' : '']"
                >
                  2Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('3Y')"
                  v-bind:class="[pickedDate === '3Y' ? 'active' : '']"
                >
                  3Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('4Y')"
                  v-bind:class="[pickedDate === '4Y' ? 'active' : '']"
                >
                  4Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('5Y')"
                  v-bind:class="[pickedDate === '5Y' ? 'active' : '']"
                >
                  5Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('10Y')"
                  v-bind:class="[pickedDate === '10Y' ? 'active' : '']"
                >
                  10Y
                </button>
                <button
                  type="button"
                  class="btn btn-candle"
                  v-on:click="_pickedDate('20Y')"
                  v-bind:class="[pickedDate === '20Y' ? 'active' : '']"
                >
                  20Y
                </button>
              </div>
            </div>
          </div>
          <div class="col col-cx"></div>
          <div
            class="col col-6 row-middle-titles"
            style="background: var(--background); border: 1px solid var(--lightbackground)"
          >
            <table
              class="table table-sm table-borderless table-data-controls"
              style="width: 100%;"
            >
              <tbody>
                <tr class="txt-label-primary-5">
                  <td class="txt-label-primary-5 text-center">
                    {{ datePrefix }}
                  </td>
                  <td class="txt-label-primary-5 text-center">
                    Open:
                  </td>
                  <td class="txt-label-primary-5 text-center">
                    High:
                  </td>
                  <td class="txt-label-primary-5 text-center">
                    Low:
                  </td>
                  <td class="txt-label-primary-5 text-center">
                    Close:
                  </td>
                  <td class="txt-label-primary-5 text-center">
                    Percentile:
                  </td>
                </tr>
                <tr>
                  <td class="txt-label-primary">
                    <div
                      id="percentileDate"
                      class="candle-hover-info text-center"
                    >
                      -
                    </div>
                  </td>
                  <td class="txt-label-primary">
                    <div
                      id="percentileOpen"
                      class="candle-hover-info text-center"
                    >
                      -
                    </div>
                  </td>
                  <td class="txt-label-primary">
                    <div
                      id="percentileHigh"
                      class="candle-hover-info  text-center"
                    >
                      -
                    </div>
                  </td>
                  <td class="txt-label-primary">
                    <div
                      id="percentileLow"
                      class="candle-hover-info text-center"
                    >
                      -
                    </div>
                  </td>
                  <td class="txt-label-primary">
                    <div
                      id="percentileClose"
                      class="candle-hover-info text-center"
                    >
                      -
                    </div>
                  </td>
                  <td class="txt-label-primary">
                    <div
                      id="percentileHover"
                      class="candle-hover-info text-center"
                    >
                      -
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Row: legend -->
    <div class="row f-row container-legends" id="percentileControls">
      <div class="col col-10 text-left">
        <table
          class="table table-sm table-responsive table-borderless table-market-legend"
          style="width: 600px; background: rgba(0,0,0,0);"
        >
          <tbody>
            <tr>
              <td class="text-center" style="width:10%;">
                <i class="fa fa-minus mr-1" style="color:var(--hedge)"></i>90th
                percentile <br /><span class="percentiles-legend">{{
                  ninety | formatNum
                }}</span>
              </td>
              <td class="text-center" style="width:10%;">
                <i class="fa fa-minus mr-1" style="color:var(--hedge)"></i>10th
                percentile <br /><span class="percentiles-legend">{{
                  ten | formatNum
                }}</span>
              </td>
              <td class="text-center" style="width:8%;">
                <i class="fa fa-minus mr-1" style="color:var(--net)"></i>Average
                <br /><span class="percentiles-legend">{{
                  ave | formatNum
                }}</span>
              </td>
              <td class="text-center" style="width:8%;">
                <i
                  class="fa fa-minus mr-1"
                  style="color:var(--textinactive)"
                ></i
                >Today <br /><span class="percentiles-legend">{{
                  tod | formatNum
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Row: Chart -->
    <div class="row f-row h-100">
      <div class="col col-12 text-center progress-div" v-if="showLoading">
        <QSLoading
          :isLoading="showLoading"
          :size="35"
          :colorTheme="colorTheme"
        />
      </div>
      <div
        class="col col-12 text-center"
        v-else-if="percentileChartData.length === 0"
        style="position: absolute; left: 0; top: 45%; z-index: 10000000;"
      >
        Failed to fetch data.<br />Please refresh page or contact support.
      </div>
      <div class="col col-12" style="height:99%; width:100%">
        <div
          class="h-100 d-flex flex-column"
          id="percentiles-chart-div"
          style="width: 100%;"
        >
          <svg id="svg-percentiles"></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { D3Chart } from "@/_core/charts/D3Chart";
import { D3HoverPercentiles } from "@/_core/charts/D3ChartHoverEffects";
import {
  candleAlpha,
  colorExpo,
  colorHedge,
  colorHedgeAlpha,
  colorNet,
  currencyFormat,
  dnCandles,
  formatPercent,
  prefixOptions,
  tFormat,
  tIntervals,
  titleTexts,
  colorExpoAlpha
} from "@/_core/_helpers/_parametric_tools";
import { lengthByDate, noLiquidity } from "@/_core/_helpers/_helpers";
import { format, select } from "d3";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Percentiles",
  components: { QSLoading },
  props: {
    chartDataRaw: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    dataReady: { required: true },
    renderPercentile: { required: true },
    showLoading: { required: true },
    spot: { required: false, default: null },
    // ============ Data Classes ===============
    processData: { required: true }
  },
  data() {
    return {
      // ========== Data =============
      ave: 0,
      currencyFormat: currencyFormat,
      D3Chart: null,
      D3HoverPercentiles: null,
      formatPercent: formatPercent,
      minMaxYAxis: [0, 1],
      ninety: 0,
      percentileChartData: [],
      percentileDates: [],
      svgNode: null,
      ten: 0,
      tod: 0,
      isCandles: null,
      // ================ Percentile Controls ================ ================
      dateFormat: "%d %b %y",
      datePrefix: "DAY:",
      interval: "day",
      pickedDate: "1Y",
      prefixOptions: prefixOptions,
      selectedDays: 261,
      tFormat: tFormat,
      tIntervals: tIntervals,
      title: "DAILY",
      titleTexts: titleTexts
    };
  },
  created() {
    this.D3Chart = new D3Chart("percentiles-chart-div", "svg-percentiles");
    this.D3HoverPercentiles = new D3HoverPercentiles();
  },
  mounted() {
    if (this.chartDataRaw.length > 0) {
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map(d => d.date)
      );
      this.dataPrepPercentiles();
    }

    let _this = this;
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  filters: {
    formatNum: function(value) {
      if (value) {
        return format(",.4r")(value);
      }
    }
  },
  watch: {
    colorTheme() {
      this.callWidth();
    },
    spot(val) {
      if (val) {
        let n = this.percentileChartData.length - 1;
        this.percentileChartData[n].close = val;
        this.percentileChartData[n].settle = val;
        this.percentileChartData[n].high = Math.max(
          val,
          this.percentileChartData[n].high
        );
        this.percentileChartData[n].low = Math.min(
          val,
          this.percentileChartData[n].low
        );
        this.calculatePercentileData();
        this.renderPercentilesMethod();
      }
    },
    dataReady() {
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map(d => d.date)
      );
      this.dataPrepPercentiles();
    },
    renderPercentile() {
      this.callWidth();
    },
    showLoading() {
      if (this.showLoading === true) {
        select("#percentiles-chart-div")
          .selectAll(".tooltip")
          .remove();
        select("#percentiles-chart-div")
          .select("svg > *")
          .remove();
      }
    }
  },
  methods: {
    callWidth() {
      if (this.percentileChartData.length > 0) {
        this.renderPercentilesMethod();
      }
    },
    // ==================== Percentiles ====================
    _pickedDate(paramInterval) {
      this.pickedDate = paramInterval;
      this.interval = this.tIntervals[this.pickedDate];
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map(d => d.date)
      );
      this.dateFormat = this.tFormat[this.interval];
      this.datePrefix = this.prefixOptions[this.interval];
      this.title = this.titleTexts[this.interval];
      this.dataPrepPercentiles();
    },
    dataPrepPercentiles() {
      this.percentileChartData = this.processData.toSlice(
        this.chartDataRaw,
        this.selectedDays
      );
      if (this.interval !== "day") {
        this.percentileChartData = this.processData.ohlcNest(
          this.percentileChartData,
          this.interval
        );
        this.isCandles = true;
      } else {
        this.isCandles = noLiquidity(this.percentileChartData);
      }
      this.percentileDates = this.percentileChartData.map(function(d) {
        return d.date;
      });
      this.minMaxYAxis = this.processData.minMax(
        this.percentileChartData,
        "high",
        "low"
      );
      this.calculatePercentileData();

      this.renderPercentilesMethod();
    },
    renderPercentilesMethod() {
      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.5,
        10,
        0.5,
        60,
        0.05,
        75,
        0.025,
        15,
        true
      );
      // === set axis
      this.svgNode = this.D3Chart.setAxis(
        this.svgNode,
        this.percentileChartData,
        this.minMaxYAxis,
        this.dateFormat,
        60,
        8,
        false,
        [],
        true,
        true,
        false,
        [],
        false
      );
      // === 90% percentile line and area
      this.D3Chart.horizontalLine(
        this.svgNode,
        this.ninety,
        colorHedge(this.colorTheme),
        1,
        true,
        false,
        colorHedgeAlpha(this.colorTheme)
      );
      // === 10% percentile line and area
      this.D3Chart.horizontalLine(
        this.svgNode,
        this.ten,
        colorHedge(this.colorTheme),
        1,
        false,
        true,
        colorHedgeAlpha(this.colorTheme)
      );
      // === average line and area
      this.D3Chart.horizontalLine(
        this.svgNode,
        this.ave,
        colorNet(this.colorTheme),
        1
      );
      // === candles
      if (this.isCandles) {
        this.svgNode = this.D3Chart.candles(
          this.svgNode,
          this.percentileChartData,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          "PERC",
          candleAlpha(this.colorTheme),
          candleAlpha(this.colorTheme)
        );
      } else {
        let minY = this.svgNode.yAxis.scale().domain()[0];
        this.percentileChartData.forEach(d => (d.zero = minY));

        this.D3Chart.linesArea(
          this.svgNode,
          this.percentileChartData,
          colorExpo(this.colorTheme),
          "rgba(0,0,0,0)",
          1.5,
          colorExpoAlpha(this.colorTheme),
          "close",
          "zero",
          false,
          0.5,
          false,
          true,
          "upperLinePerc",
          "lowerLinePerc",
          "areaPerc"
        );
      }
      // === custom hover effects and info
      this.D3HoverPercentiles.hoverFct(
        this.svgNode,
        this.percentileChartData,
        "PERC",
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent,
        this.colorTheme,
        this
      );
    },
    calculatePercentileData() {
      if (this.percentileChartData.length > 0) {
        let close = Array.from(this.percentileChartData, d => d.close);
        this.tod = close[close.length - 1];
        this.ave = this.processData.average(close);
        let sorted = JSON.parse(JSON.stringify(close)).sort(function(a, b) {
          return a - b;
        });
        this.ninety = this.processData.percentile(sorted, 0.9);
        this.ten = this.processData.percentile(sorted, 0.1);
        let vis = this;
        this.percentileChartData.forEach(function(d, i) {
          d.perc = vis.processData.percentileNum(close, close[i]);
        });
      }
    }
  }
};
</script>

<style scoped>
.container-legends {
  position: absolute;
  left: 0;
  top: 99px;
  z-index: 0;
}
@media (min-width: 1440px) {
  .container-legends {
    top: 110px;
  }
}
</style>
